import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
import './assets/loading.css';
export var LoaderContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: theme.palette.mode !== 'dark' ? '#ffffff' : undefined,
    });
});
export function Loading() {
    return (_jsx(LoaderContainer, { children: _jsx("img", { style: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                animation: 'loadingAnimation 5s infinite',
            }, src: "https://s3.eu-west-1.amazonaws.com/altaria-bucket.madboxgames.io/icons/madbox_cross.svg", width: 100, height: 100, alt: "loading" }, void 0) }, void 0));
}
